import { cn } from "@/lib/utils";
import { VEHICLE_TYPES } from "../../lib/constants";
import { visualList } from "../../lib/model";
import { Field, TextInput, NSelect, Panel, StepTitle } from "../common/Field";

const FIELDS = [
  ["placa", "Placa"], ["cliente", "Cliente"], ["marca", "Marca"], ["modelo", "Modelo"], ["ano", "Ano"], ["cor", "Cor"],
  ["data_inspecao", "Data da inspeção", "date"], ["hora_inspecao", "Hora da inspeção", "time"], ["executor", "Executor"],
  ["numero_ordem_servico", "Nº Ordem de Serviço"],
];
const STATUSES = [["OK", "OK"], ["ANOMALIA", "ANOMALIA"], ["NA", "N/A"]];

export default function Step1Vehicle({ insp, update }) {
  const v = insp.vehicle || {};
  const setV = (k) => (val) => update("vehicle", (prev) => ({ ...prev, [k]: k === "placa" ? val.toUpperCase() : val }));
  const list = visualList(insp.visual);
  const setItem = (item, patch) => update("visual", () => list.map((x) => (x.item === item ? { ...x, ...patch } : x)));
  const anomalyCount = list.filter((x) => x.status === "ANOMALIA").length;

  return (
    <div className="flex flex-col gap-6">
      <StepTitle n={1} title="Identificação do veículo" subtitle="Dados do veículo, cliente e da ordem de serviço, tipo de veículo e inspeção visual preliminar." />
      <Panel title="Dados do veículo" testId="panel-vehicle">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {FIELDS.map(([k, label, type]) => (
            <Field key={k} label={label}>
              <TextInput testId={`vehicle-${k}-input`} type={type || "text"} value={v[k]} onChange={setV(k)} className={k === "placa" ? "font-mono font-bold text-[#FFD500] tracking-widest" : ""} />
            </Field>
          ))}
          <Field label="Tipo de veículo">
            <NSelect testId="vehicle-tipo-select" value={v.tipo_veiculo} onChange={setV("tipo_veiculo")} options={VEHICLE_TYPES} placeholder="Selecione..." />
          </Field>
          {v.tipo_veiculo === "Outro" && (
            <Field label="Especifique o tipo"><TextInput testId="vehicle-tipo-outro-input" value={v.tipo_outro} onChange={setV("tipo_outro")} /></Field>
          )}
        </div>
      </Panel>

      <Panel title="Inspeção visual" subtitle="Marque cada item como OK, ANOMALIA ou N/A (não aplicável)." testId="panel-visual"
        actions={<span className="font-mono text-xs text-slate-400">{anomalyCount} ANOMALIA(S) MARCADA(S)</span>}>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-x-6 gap-y-1">
          {list.map((x, i) => (
            <div key={x.item} className="flex flex-wrap sm:flex-nowrap items-center gap-2 py-2 border-b border-[#1E2F45]/60" data-testid={`visual-item-${i}`}>
              <span className="font-mono text-[10px] text-slate-600 w-5">{String(i + 1).padStart(2, "0")}</span>
              <span className={cn("flex-1 text-sm min-w-[180px]", x.status === "ANOMALIA" ? "text-white font-medium" : "text-slate-300")}>{x.item}</span>
              <div className="flex gap-1">
                {STATUSES.map(([val, label]) => (
                  <button key={val} type="button" data-testid={`visual-item-${i}-${val.toLowerCase()}`} onClick={() => setItem(x.item, { status: x.status === val ? "" : val })}
                    className={cn("h-7 px-2 rounded-sm border font-mono text-[10px] font-bold transition-colors",
                      x.status === val
                        ? val === "ANOMALIA" ? "bg-[#FF0000] border-[#FF0000] text-white" : val === "OK" ? "bg-emerald-500/20 border-emerald-500 text-emerald-300" : "bg-slate-600/30 border-slate-500 text-slate-200"
                        : "border-[#1E2F45] text-slate-500 hover:text-slate-200")}>
                    {label}
                  </button>
                ))}
              </div>
              {x.status === "ANOMALIA" && (
                <input data-testid={`visual-item-${i}-obs`} value={x.obs || ""} onChange={(e) => setItem(x.item, { obs: e.target.value })} placeholder="Observação"
                  className="w-full h-8 bg-[#050B10] border border-[#1E2F45] rounded-sm px-2 text-xs focus:outline-none focus:border-[#FFD500]" />
              )}
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
